import { createApp } from "vue";
import App from "./App.vue";
import * as Sentry from "@sentry/vue";
// import "~/styles/element/index.scss";
import { abilitiesPlugin } from '@casl/vue'
import ability from '~/shared/casl/ability'
import "nprogress/nprogress.css"
// import ElementPlus from "element-plus";
// import all element css, uncommented next line
// import "element-plus/dist/index.css";

// or use cdn, uncomment cdn link in `index.html`

import "~/styles/index.scss";   
import "uno.css";

// If you want to use ElMessage, import it.
import "element-plus/theme-chalk/src/message.scss"
import "element-plus/theme-chalk/src/message-box.scss"
import "element-plus/theme-chalk/src/message-box.scss"
import "element-plus/theme-chalk/src/overlay.scss"
import "element-plus/theme-chalk/src/message-box.scss"
import "element-plus/theme-chalk/src/common/popup.scss"
import { createPinia } from 'pinia';
import i18n from './i18n'
const pinia = createPinia();

import router from "./router";
import { VueQueryPlugin } from '@tanstack/vue-query'
const app = createApp(App);
app.use(pinia);
app.use(i18n)
app.use(VueQueryPlugin,{
  queryClientConfig : {
    defaultOptions: {
      queries: {
        retry : 1,
        refetchOnWindowFocus: false,
      },
    },
  }
})
app.use(abilitiesPlugin, ability, {
  useGlobalProperties: true,
})
app.use(router)

Sentry.init({
    app,
    dsn: "https://13c784b1f0080dc9d0c08237dcb6faf6@o4508649510404096.ingest.de.sentry.io/4508649516826704",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
      Sentry.browserApiErrorsIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [ /^https:\/\/admin-tms\.rello\/api/, /^https:\/\/admin-tms\.simplex\.uz\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

// app.use(ElementPlus);
app.mount("#app");
